module.exports = __webpack_public_path__ + "static/img/server-ip.025bcd68.png";